var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "filter",
    [
      _c("feGaussianBlur", {
        attrs: { in: "SourceAlpha", stdDeviation: "10", result: "DROP" }
      }),
      _c("feOffset", {
        attrs: {
          in: "DROP",
          dx: _vm.offsetX,
          dy: _vm.offsetY,
          result: "DROPSHADOW"
        }
      }),
      _c("feColorMatrix", {
        attrs: {
          type: "matrix",
          in: "DROPSHADOW",
          result: "FINALSHADOW",
          values: _vm.colorMatrix
        }
      }),
      _c(
        "feMerge",
        [
          _c("feMergeNode", { attrs: { in: "FINALSHADOW" } }),
          _c("feMergeNode", { attrs: { in: "SourceGraphic" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }